<template>
  <div style="width: 100%">
    <v-btn v-if="exame.imageUrl" :href="exame.imageUrl" target="_blank" rel="noopener noreferrer" :disabled="exame.status !== 'Liberado'" :dark="exame.status === 'Liberado'" elevation="0" class="rounded-lg" block color="primary">
      Acessar
      <v-icon right>
        mdi-open-in-new
      </v-icon>
    </v-btn>
    <v-btn v-else :disabled="exame.status !== 'Liberado'" :dark="exame.status === 'Liberado'" elevation="0" class="rounded-lg" block color="primary" :loading="loading" @click="downloadPDF(exame.pdf)">
      Acessar
    </v-btn>
    <a ref="downloadLink" style="display: none"></a>
  </div>
</template>

<script>
import { api } from '@/api'

function base64ToArrayBuffer (data) {
  const bString = window.atob(data)
  const bLength = bString.length
  const bytes = new Uint8Array(bLength)
  for (let i = 0; i < bLength; i++) {
    const ascii = bString.charCodeAt(i)
    bytes[i] = ascii
  }
  return bytes
};

export default {

  name: 'BtnDownload',

  props: {
    exame: {
      type: Object,
      required: true
    },
    print: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      loading: false
    }
  },

  methods: {
    async downloadPDF (reportParams) {
      this.loading = true
      try {
        const response = await api.post('/report/generate', this.exame.reportParams)

        console.log(response.data)

        const bufferArray = base64ToArrayBuffer(response.data.base64string)
        const blobStore = new Blob([bufferArray], { type: 'application/pdf' })

        const data = window.URL.createObjectURL(blobStore)

        const pdfWindow = window.open(data)
        if (this.print) {
          pdfWindow.print()
        }

        // window.URL.revokeObjectURL(data)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>

</style>
